import FilesList from "./FileList";
import UploadFiles from "./Uploadfiles";

const ExpedientsDocs = ({ expedient }) => {
  return (
    <div className="space-y-6">
      <FilesList expedient={expedient} />
      <UploadFiles expedient={expedient} />
    </div>
  );
};

export default ExpedientsDocs;